import { render } from "./nav.vue?vue&type=template&id=08f28b28"
const script = {}

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__